import { ReactNode, useState } from "react";
import { ReactComponent as ChevronUp } from "assets/images/iconsV2/chevron-up.svg";
import "./CardAccordion.scss";

export interface CardAccordionProps {
  /**
   * The title of the card accordion.
   */
  accordionTitle?: string | ((isOpen: boolean) => string);
  /**
   * Indicate whether the card accordion is opened by default.
   */
  defaultOpened?: boolean;
  /**
   * Class to pass into container
   */
  containerClassName?: string;
  /**
   * The content of the card accordion.
   */
  children: ReactNode;
}

const CardAccordion = function (props: CardAccordionProps) {
  const { accordionTitle, defaultOpened, containerClassName, children } = props;
  const [isOpen, setIsOpen] = useState(defaultOpened ?? false);

  const title = typeof accordionTitle === "function" ? accordionTitle(isOpen) : accordionTitle;

  return (
    <div>
      {isOpen && <div>{children}</div>}
      <div className={`v2-card-accordion ${containerClassName}`} onClick={() => setIsOpen((prev) => !prev)}>
        <ChevronUp className={isOpen ? "" : "rotate-180"} style={{ transitionDuration: "500ms" }} />
        <p className="m-0 text-sm">{title}</p>
      </div>
    </div>
  );
};

CardAccordion.defaultProps = {
  accordionTitle: "",
  defaultOpened: false,
  containerClassName: "",
};

export default CardAccordion;
